import { render } from "./PageNotFound.vue?vue&type=template&id=5f7719ff&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=5f7719ff&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7719ff"]])

export default __exports__